module.exports = __webpack_public_path__ + "images/q3-otro-color-img.jpg";